import React from "react";
import { useNavigate } from "react-router-dom";
import ThemeToggle from "../Components/ThemeToggle";
import { LogOut, Menu } from "lucide-react";

const logout = (navigate) => {
  localStorage.removeItem("authToken");
  localStorage.setItem("isAuthenticated", "false");
  navigate("/login");
};

const DashboardNav = ({ toggleSidebar }) => {
  const navigate = useNavigate();
  
  return (
    <nav className="flex items-center justify-between w-full h-20 px-6 bg-white dark:bg-zinc-900 border-b border-zinc-200 dark:border-zinc-800 shrink-0">
      
      {/* Left: Mobile Menu Toggle */}
      <div className="flex items-center">
        <button
          onClick={toggleSidebar}
          className="p-2 -ml-2 text-zinc-600 hover:text-zinc-900 hover:bg-zinc-100 rounded-lg lg:hidden dark:text-zinc-400 dark:hover:bg-zinc-800 dark:hover:text-white transition-colors focus:outline-none"
        >
          <Menu size={24} strokeWidth={1.5} />
        </button>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-4">
        <ThemeToggle />
        
        <div className="w-[1px] h-6 bg-zinc-200 dark:bg-zinc-800 mx-2"></div>
        
        <button
          onClick={() => logout(navigate)}
          className="flex items-center gap-2 px-4 py-2 text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 rounded-xl transition-colors focus:outline-none"
        >
          <LogOut size={16} strokeWidth={2} />
          <span className="hidden sm:inline">Logout</span>
        </button>
      </div>

    </nav>
  );
};

export default DashboardNav;
